var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOpenIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 16 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.961 0h5.82v5.82h-1.68V2.86l-6.16 6.16-1.18-1.18 6.16-6.16h-2.96zm4.14 13.32V8.5h1.68v4.82q0 .68-.5 1.18t-1.18.5H2.461q-.7 0-1.19-.5a1.63 1.63 0 0 1-.49-1.18V1.68q0-.68.49-1.18t1.19-.5h4.82v1.68h-4.82v11.64z"
})));
export default SvgOpenIn;